<div
  *ngIf="downloadContent$ | async as downloadContent"
  class="pa4 flex justify-center items-center"
>
  <!-- Desktop: Render badges from CMS if available -->
  <ng-container *ngIf="isDesktop && content?.length">
    <ng-container *ngFor="let logo of content">
      <a
        [href]="logo.storeType === 'apple' ? appleStoreUrl : googlePlayStoreUrl"
        class="dib mr2"
      >
        <img
          [src]="
            logo.storeType === 'apple'
              ? appConfigService.mobileAppStoreBadges.apple[currentLanguage]
              : appConfigService.mobileAppStoreBadges.android[currentLanguage]
          "
          [alt]="
            logo.storeType === 'apple'
              ? downloadContent.appStoreDownload
              : downloadContent.googlePlayDownload
          "
          [class]="
            logo.storeType === 'apple' ? 'app-store-badge' : 'play-store-badge'
          "
        />
      </a>
    </ng-container>
  </ng-container>

  <!-- Mobile: Display the appropriate badge based on device type -->
  <a *ngIf="!isDesktop" [href]="mobileAppStoreUrl" class="db center">
    <img
      [src]="mobileAppStoreBadge"
      [alt]="
        deviceType === DeviceType?.iOS
          ? downloadContent.appStoreDownload
          : downloadContent.googlePlayDownload
      "
      [class]="badgeClass"
    />
  </a>
</div>
